import React from 'react';
import StatCard from '../../components/ui/StatCard.jsx';
import Card from '../../components/ui/Card.jsx';
import { useApi } from '../../hooks/useApi.js';

export default function StaffDashboard() {
  const { data: requestsData } = useApi('/api/requests');
  const { data: studentsData } = useApi('/api/students?limit=100');
  const { data: surveyData } = useApi('/api/surveys/active');

  const requests = requestsData?.items || [];
  const pending = requests.filter((req) => req.status === 1).length;
  const students = studentsData?.items || [];
  const activeSurvey = surveyData?.active;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Advisor Dashboard</h1>
          <p className="subtle">Monitor requests, student activity, and surveys.</p>
        </div>
      </div>

      <div className="grid three">
        <StatCard label="Pending Requests" value={String(pending)} trend="Requires review" />
        <StatCard label="Active Students" value={String(students.length)} trend="Loaded from roster" />
        <StatCard label="Surveys" value={activeSurvey ? '1 Live' : '0 Live'} trend={activeSurvey ? activeSurvey.semester || 'Active' : 'No active survey'} />
      </div>

      <div className="grid two">
        <Card title="Recent Requests">
          <ul className="list">
            {requests.slice(0, 3).map((req) => (
              <li key={req.id}>REQ-{req.id}: {req.remove_course || '—'} → {req.add_course || '—'}</li>
            ))}
            {requests.length === 0 ? <li>No requests yet.</li> : null}
          </ul>
        </Card>
        <Card title="Operational Notes">
          <p className="subtle">Remember to close the survey before scheduling courses.</p>
        </Card>
      </div>
    </div>
  );
}
